import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const CustomizedComponent = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: "large",
  webkitUserSelect: "none",
  userSelect: "none",
}));

const OmniDialogMessage = props => {
  const { children, ...other } = props;
  return (
    <CustomizedComponent variant="body1" {...other}>
      {children}
    </CustomizedComponent>
  );
};

export default OmniDialogMessage;
